



















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { passwordValidator, checkPasswordValidator, phoneNumberValidator, usernameValidator, nameValidator } from '../../utils/validator'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
import SelectRegion from '@/components/Select/SelectRegion.vue'
@Component({
  components: {
    SelectRegion,
  },
})
export default class CreateManualFailure extends Vue {
  private showDialog: boolean = false
  private submitLoading: boolean = false
  private upStyleType: any[] = [
    { label: '设备上报', value: 1 },
    { label: '人工上报', value: 2 },
  ]
  private formData: any = {
    uName: '',
    upStyle: 2,
    content: '',
    devId: [],
  }
  private rules = {
    devId: { required: true, message: '请选择故障设备' },
    uName: { required: true, message: '请输入用户名称' },
    upStyle: { required: true, message: '请选择上报方式' },
    content: { required: true, message: '请输入故障原因' },
  }

  public show() {
    this.showDialog = true
  }
  public cancel() {
    this.showDialog = false
  }
  public submitForm(refName: string) {
    (this.$refs as any)[refName].validate().then(() => {
      const { uName = '', upStyle = 2, content = '', devId = [] } = this.formData || {}
      this.submitLoading = true
      api.addDevExcaption({
        orgId: UserModule.orgInfo.orgId,
        uName,
        upStyle,
        content,
        devId: devId[devId.length - 1],
        netId: devId[devId.length - 2],
      }).then(() => {
        this.$message.success('添加成功')
        this.cancel()
        this.$emit('success')
      }).finally(() => {
        this.submitLoading = false
      })
      console.log(this.formData.value)
    })
  }
}
